import { getIam, postIam } from '../../apis';
import { IS_MOBILE, SDK_DOMAIN } from '../../constants';
import {
  deserialize,
  getIframe,
  getLocationPath,
  serialize,
  setAddEventListener,
  setIframeInnerHtml,
  showBottomSheet,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setAlertModal, showAlertModal } from '../components/alert';

const Terms = {
  render: async () => {
    return `
    <div>
      <a id="connect_pay_back_button" class="c_back"></a>
    </div>
    <div class="c_title1">약관동의</div>
    <div class="form-check c_terms_all m_b_20">
      <input class="form-check-input custom-control-input skin1_check" type="checkbox" value="" id="terms_all">
      <label class="form-check-label custom-control-label skin1_check_label c_label4_3" for="terms_all" id="terms_all_label">&nbsp;전체동의</label>
    </div>
    <div id="termsList"></div>
    <div class="bottom_btn_wrapper">
      <button id="terms_next" type="button" class="btn c_btn1 skin1_btn">다음</button>
    </div>

    <form id="reqKMCISForm" method="post" action="#">
      <input type="hidden" id="tr_cert" name="tr_cert" />
      <input type="hidden" id="tr_url" name="tr_url" />
      <input type="hidden" id="tr_add" name="tr_add" />
    </form>
    `;
  },
  afterRender: async () => {
    setAlertModal();

    const userKey = sessionStorage.getItem('CONPAY_USER_KEY');
    let termsList = [];
    let termsListHTML = '';
    let plusInfo = '';

    try {
      const termsRes = await getIam(`terms?userKey=${userKey}`);
      termsList = termsRes.resultData.termsInf;
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e);
      console.error(e.resultMessage || e);
    }

    termsList.forEach((term, index) => {
      const termsPath = `${SDK_DOMAIN}/terms/${term.termsFileName}`;

      termsListHTML += `
        <div class="form-check m_b_20 c_box">
          <input class="form-check-input custom-control-input skin1_check" type="checkbox" value="" id="terms_${index}">
          <label class="form-check-label custom-control-label skin1_check_label c_label4" for="terms_${index}">&nbsp;${
        term.termsKndName
      } ${term.mandtYn === 'Y' ? '(필수)' : '(선택)'}</label>
          <img src="${SDK_DOMAIN}/images/icon_more.svg" value="${serialize({
        termsKndName: term.termsKndName,
        termsPath,
      })}" />
        </div>
      `;

      if (plusInfo != '') plusInfo += '@';
      plusInfo += `${term.termsKndCode}#${term.verno}`;
    });
    setIframeInnerHtml('termsList', termsListHTML);

    const toggleAll = () => {
      const checkedAll = getIframe().getElementById('terms_all').checked;

      termsList.forEach((_, i) => {
        getIframe().getElementById(`terms_${i}`).checked = checkedAll;
      });
    };

    const setCheckAll = () =>
      (getIframe().getElementById('terms_all').checked = isCheckedAll('all'));

    const isCheckedAll = (type) => {
      let checkedAll = true;
      let checkedMandtAll = true;

      termsList.forEach((term, i) => {
        checkedAll =
          checkedAll && getIframe().getElementById(`terms_${i}`).checked;

        if (type === 'mandatory' && term.mandtYn === 'N') return false;
        checkedMandtAll =
          checkedMandtAll && getIframe().getElementById(`terms_${i}`).checked;
      });

      return type === 'all' ? checkedAll : checkedMandtAll;
    };

    const handleNext = async () => {
      if (!isCheckedAll('mandatory')) {
        showAlertModal('알림', '필수약관에 동의해주세요.');
      } else {
        // 본인인증 연동
        try {
          const data = await postIam('getKmcertInfo', { plusInfo });
          const locationPath = getLocationPath();

          getIframe().getElementById('tr_cert').value = data.resultData.tr_cert;
          getIframe().getElementById(
            'tr_url'
          ).value = `${locationPath}#conpay_kmcert-callback?userKey=${userKey}`;
          getIframe().getElementById('tr_add').value = 'N';
        } catch (e) {
          showBottomSheet('오류', e.resultMessage || e);
          console.error(e.resultMessage || e);
        }

        // 모바일일 경우
        if (IS_MOBILE) {
          getIframe().getElementById('reqKMCISForm').target = '';
          getIframe().getElementById('reqKMCISForm').action =
            process.env.KMCERT_URL;
          getIframe().getElementById('reqKMCISForm').submit();
        }
        // 모바일이 아닐 경우
        else {
          const KMCIS_window = window.open(
            '',
            'KMCISWindow',
            'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250'
          );

          if (KMCIS_window == null) {
            showAlertModal(
              '오류',
              ' ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.'
            );
          } else {
            getIframe().getElementById('reqKMCISForm').target = 'KMCISWindow';
            getIframe().getElementById('reqKMCISForm').action =
              process.env.KMCERT_URL;
            getIframe().getElementById('reqKMCISForm').submit();
          }
        }
      }
    };

    termsList.forEach((_, index) => {
      setAddEventListener(`terms_${index}`, () => setCheckAll());
    });

    getIframe()
      .querySelectorAll('#termsList > div > img')
      .forEach((element) => {
        const termsInfo = deserialize(element.getAttribute('value'));
        element.addEventListener('click', () => {
          pushRouter(
            {
              termsKndName: termsInfo.termsKndName,
              termsPath: termsInfo.termsPath,
            },
            null,
            routes.termsView.hashPath
          );
        });
      });

    setAddEventListener('terms_all_label', () => toggleAll());
    setAddEventListener('terms_all', () => toggleAll());
    setAddEventListener('terms_next', () => handleNext());
    setAddEventListener('connect_pay_back_button', () => history.back());
  },
};
export default Terms;
